export enum RouteData {
  HasBackgroundPattern,
  HasWhiteBackground,
}
